import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
}
export function Card({
  children,
  className = '',
  title,
  description
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden ${className}`} data-id="element-29">
      {(title || description) && <div className="px-6 py-4 border-b border-gray-50" data-id="element-30">
          {title && <h3 className="text-lg font-semibold text-gray-900 font-serif" data-id="element-31">
              {title}
            </h3>}
          {description && <p className="text-sm text-gray-500 mt-1" data-id="element-32">{description}</p>}
        </div>}
      <div className="p-6" data-id="element-33">{children}</div>
    </div>;
}